<template>
  <div v-if="loading" class="mpf-payment-confirmation-view__loading">Loading…</div>

  <template v-else-if="confirmation">
    <template v-if="confirmation.invoicePaid">
      <h1 class="mpf-heading-l">Payment confirmed</h1>
      <p>
        Thank you, invoice <strong>{{ confirmation.invoiceNumber }}</strong> has been paid. A
        receipt will be sent to you by email.
      </p>
    </template>

    <template v-else>
      <h1 class="mpf-heading-l">Payment successful</h1>
      <p>
        Thank you, your payment for invoice <strong>{{ confirmation.invoiceNumber }}</strong> has
        been taken successfully. A confirmation email will be sent to you shortly.
      </p>
      <p>If you have any questions, please contact your practice.</p>
    </template>
  </template>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { fetchInvoicePaymentConfirmationApi } from '@/services/payment.service';
  import { InvoicePaymentConfirmation } from '@/types/payment';

  const route = useRoute();
  const invoiceId = route.params.invoiceId as string;

  const loading = ref(true);
  const confirmation = ref<InvoicePaymentConfirmation | null>(null);

  onMounted(async () => {
    try {
      confirmation.value = await fetchInvoicePaymentConfirmationApi(invoiceId);
    } finally {
      loading.value = false;
    }
  });
</script>
